import React, { useState } from "react";
import "../../../../style/main.scss";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { Icon } from "@iconify/react";
const PostModal = ({ show, handleClose }) => {
  // const [show, setShow] = useState(false);
  const [refreshModal, setRefeshModal] = useState(false);

  // const handleClose = () => setShow(false);
  // const handleShow = () => setShow(true);

  //   Refresh Modal
  const handleRefreshClose = () => setRefeshModal(false);
  const handleRefreshShow = () => setRefeshModal(true);

  return (
    <div>
      {/* Post Modal  */}

      <Modal show={show} onHide={handleClose} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title> </Modal.Title>
        </Modal.Header>
        <Modal.Body className="post-modal-body">
          <h4>
            Below You Can Edit The Template / Format That voxr Will Write It's
            Post Call Notes In
          </h4>
          <div className="content mt-4">
            <ul contentEditable>
              <p contentEditable>General context / background on prospect</p>
              <li>- note</li>
              <li>- note</li>
              <li>- etc</li>
            </ul>
          </div>
          <div className="refresh-btn" onClick={handleRefreshShow}>
            <Icon icon="tabler:refresh" width="30" height="30" />
          </div>
          <div className="footer-btns mt-4">
            <Button variant="primary" onClick={handleClose}>
              Test This Template
            </Button>
            <Button variant="primary" onClick={handleClose}>
              Save & Publish
            </Button>
          </div>
        </Modal.Body>
      </Modal>
      {/* Refresh Modal */}
      <Modal
        show={refreshModal}
        onHide={handleRefreshClose}
        centered
        // size="lg"
        className="bg-light"
      >
        <Modal.Body className="refresh-body-modal">
          <h4>
            Do you want to reset to the default note taking template / format?
            You will not be able to recover your current template.
          </h4>
          <div className="refresh-footer mt-4">
            <Button variant="primary" onClick={handleRefreshClose}>
              Yes, Reset
            </Button>
            <Button className="bg-danger" onClick={handleRefreshClose}>
              No, Nevermind
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default PostModal;
